import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
 
import { DataService, Dialog, GetCategoryList } from '@ishop/admin-ui/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Component({
    selector: 'vdr-select-vendor-category-dialog',
    templateUrl: './select-vendor-category-dialog.component.html',
    styleUrls: ['./select-vendor-category-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectVendorCategoryDialogComponent implements Dialog<string[]>, OnInit {
    resolveWith: (result?: string[]) => void;
    categories$: Observable<GetCategoryList.Items[]>;
    selectedCategoryIds: string[] = [];

    constructor(private dataService: DataService) {}

    ngOnInit() {
        this.categories$ = this.dataService.settings
            .getCategories()
            .mapStream((res) => res.vendorCategories.items);
    }

    cancel() {
        this.resolveWith();
    }

    add() {
        this.resolveWith(this.selectedCategoryIds);
    }
}
